/** @format */

import React from 'react'
import { Tooltip, _$, Icon } from 'kpc-react'
import styled from 'styled-components'

interface FormItemLabelTooltipProps {
  className?: string
  label: string
  tips: string
}
const FormItemLabelTooltip: React.FC<FormItemLabelTooltipProps> = ({ className, label, tips }) => {
  return (
    <span className={className}>
      {label}
      <Tooltip canHover b-content={<span>{tips}</span>}>
        <Icon className="icontip ion-help-circled" />
      </Tooltip>
    </span>
  )
}

export default styled(FormItemLabelTooltip)`
  .icontip {
    margin-left: 4px;
    cursor: pointer;
    font-size: 14px;
  }
`
